import { OverviewItem } from './OverviewItem';

interface OverviewSocialMediaItemProps {
  socialsCount: number;
}

export const OverviewSocialMediaItem = ({
  socialsCount,
}: OverviewSocialMediaItemProps) => {
  const label =
    socialsCount !== 0
      ? `${socialsCount} social media identified`
      : 'No social media found';
  const buttonLabel = 'View details';
  const iconName = 'Share';
  const section = 'social-media-section';
  const containerProps = {
    'data-cy': 'overview-social-media-item',
  };
  return (
    <OverviewItem
      label={label}
      iconName={iconName}
      buttonLabel={buttonLabel}
      section={section}
      otherProps={{ containerProps }}
    />
  );
};
